import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MailMergeTemplateProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `MailMergeTemplate/${props.mailMergeTemplateId}`, method: 'GET', secure: true });
    }, [execute]);

    const selectAttachmentsRecord = useCallback(async (props) => {
        await execute({ scope: 'selectAttachments', url: `MailMergeTemplate/GetMailMergeTemplateAttachments/${props.mailMergeTemplateId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `MailMergeTemplate`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MailMergeTemplate/${props.mailMergeTemplateId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'MailMergeTemplate', method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `MailMergeTemplate/${props.mailMergeTemplateId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const sendMailCopy = useCallback(async (props) => {
        await execute({ scope: 'sendMail', url: `MailMerges/SendEmailTemplate`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const value = { selectRecord, selectAttachmentsRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData, sendMailCopy };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMailMergeTemplateStore = () => React.useContext(Context);
